/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import eventMessages from './eventMessages';

// NOTE: 'events' is for storing an offline list of events to show when offline but 'syncEvents'
// is for storing offline submitted pending events to sync with back end when get online

import connector from '../connector';

const addEventsList = (eventsList) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('events', 'readwrite');
        const eventsStore = transaction.objectStore('events');

        eventsStore.clear(); // delete all of the previously added animals to add the new list

        eventsList.forEach(singleEvent => {
            eventsStore.add(singleEvent);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEventsList = () => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('events', 'readonly');
        const eventsStore = transaction.objectStore('events');

        const allEvents = eventsStore.getAll();

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: allEvents.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getEvent = (id) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('events', 'readonly');
        const eventsStore = transaction.objectStore('events');


        const eventId = id === 'support' ? parseInt(localStorage.getItem('support_log')) : parseInt(id);

        const event = eventsStore.get(eventId);

        transaction.oncomplete = () => {
            db.close();
            if (event.result && event.result) {
                resolve({ success: true, event: event.result });
            }
            else {
                reject({ success: false, error: 404 });
            }
        };
    }
    catch (error) {
        reject({ success: false, error })
    }
});

const getFilteredEventsList = (selectedFilters) => new Promise(async (resolve, reject) => {

    try {
        const db = await connector();
        const transaction = db.transaction('events', 'readonly');
        const eventsStore = transaction.objectStore('events');

        const allEvents = eventsStore.getAll();

        transaction.oncomplete = () => {
            if (allEvents.result) {
                db.close();

                // filter by selected farms
                let farmsFilteredArray = [];
                if (selectedFilters.farmId?.length) {
                    for (const singleEvent of allEvents.result) {
                        if (selectedFilters.farmId.indexOf(parseInt(singleEvent.farmId)) > -1) {
                            farmsFilteredArray.push(singleEvent);
                        }
                    }
                }
                else {
                    farmsFilteredArray = [...allEvents.result];
                }

                // filter by category
                let categoryFilteredArray = [];
                if (selectedFilters.category) {
                    for (const singleEvent of farmsFilteredArray) {
                        if (parseInt(singleEvent.eventCategoryId) === parseInt(selectedFilters.category)) {
                            categoryFilteredArray.push(singleEvent);
                        }
                    }
                }
                else {
                    categoryFilteredArray = [...farmsFilteredArray];
                }

                // filter by 'user submitted'
                let userSubmittedFilteredArray = [];
                if (selectedFilters.generatedBy === 1) {
                    for (const singleEvent of categoryFilteredArray) {
                        if (singleEvent.generatedBy === 1) {
                            userSubmittedFilteredArray.push(singleEvent);
                        }
                    }
                }
                else {
                    userSubmittedFilteredArray = [...categoryFilteredArray];
                }

                // filter by animalId
                let animalIdFilteredArray = [];
                if (selectedFilters.animalId) {
                    for (const singleEvent of userSubmittedFilteredArray) {
                        if (parseInt(singleEvent.animalId) === parseInt(selectedFilters.animalId)) {
                            animalIdFilteredArray.push(singleEvent);
                        }
                    }
                }
                else {
                    animalIdFilteredArray = [...userSubmittedFilteredArray];
                }

                // get paginated scope
                animalIdFilteredArray.reverse();
                const filteredArray = [...animalIdFilteredArray.splice(selectedFilters.start, selectedFilters.end + 1)];

                resolve({ success: true, data: filteredArray });
            }
            else {
                reject({ success: false, error: null });
            }
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getFilteredEventsListByAnimalId = (
    animalId = null,
    start = 0,
    end = 15,
    justUserSubmitted = false,
    category = null
) => new Promise(async (resolve, reject) => {
    try {
        if (animalId) {
            const db = await connector();
            const transaction = db.transaction('events', 'readonly');
            const eventsStore = transaction.objectStore('events');
            const animalIdIndex = eventsStore.index('AnimalIdIndex');

            const allEvents = animalIdIndex.getAll(parseInt(animalId));


            transaction.oncomplete = () => {
                if (allEvents.result) {
                    db.close();

                    // filter by category
                    let categoryFilteredArray = [];
                    if (category) {
                        for (const singleEvent of allEvents.result) {
                            if (parseInt(singleEvent.eventCategoryId) === parseInt(category)) {
                                categoryFilteredArray.push(singleEvent);
                            }
                        }
                    }
                    else {
                        categoryFilteredArray = [...allEvents.result];
                    }

                    // filter by 'user submitted'
                    let userSubmittedFilteredArray = [];
                    if (justUserSubmitted) {
                        for (const singleEvent of categoryFilteredArray) {
                            if (singleEvent.generatedBy === 1) {
                                userSubmittedFilteredArray.push(singleEvent);
                            }
                        }
                    }
                    else {
                        userSubmittedFilteredArray = [...categoryFilteredArray];
                    }

                    // get paginated scope
                    userSubmittedFilteredArray.reverse();
                    const filteredArray = [...userSubmittedFilteredArray.splice(start, end + 1)];

                    resolve({ success: true, data: filteredArray });
                }
                else {
                    reject({ success: false, error: null });
                }
            };
        }
        else {
            reject({ success: false, error: 'Animal ID not provided' });
        }
    }
    catch (error) {
        reject({ success: false, error });
    }
});


const findEvents = (searchTerm) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('events', 'readonly');
        const eventsStore = transaction.objectStore('events');

        const allEvents = eventsStore.getAll();

        transaction.oncomplete = async () => {
            db.close();
            const eventsList = allEvents.result;

            const filteredEvents = [];
            for (const singleEvent of eventsList) {
                if (
                    (singleEvent?.msgText?.toLowerCase().indexOf(searchTerm.toString().toLowerCase()) > -1) ||
                    (singleEvent?.earTagNo?.toLowerCase().indexOf(searchTerm.toString().toLowerCase()) > -1) ||
                    (singleEvent?.extraProperties?.notes?.indexOf(searchTerm.toString()) > -1)
                ) {
                    filteredEvents.push(singleEvent);
                }
                else {
                    // if search term not exist in event itself, then search in event's messages
                    try {
                        // eslint-disable-next-line no-await-in-loop
                        const eventMessagesList = await eventMessages
                            .getEventMessagesListByEventId(parseInt(singleEvent.id));
                        if (eventMessagesList && eventMessagesList.success &&
                            eventMessagesList.data && eventMessagesList.data.length) {
                            const messagesWithSearchTerm = eventMessagesList.data.filter(message => {
                                if (message && message.messageText &&
                                    (message?.messageText?.toString()?.toLowerCase()
                                        ?.indexOf(searchTerm.toString().toLowerCase()) > -1)) {
                                    return true;
                                }
                                else { return false }
                            });
                            if (messagesWithSearchTerm && messagesWithSearchTerm.length) {
                                filteredEvents.push({ ...singleEvent, relatedMessages: messagesWithSearchTerm });
                            }
                        }
                    }
                    // eslint-disable-next-line no-empty
                    catch { }
                }
            }
            const sortedResults = filteredEvents.sort((a, b) => new Date(a.timeStamp) -
                new Date(b.timeStamp)).reverse();
            resolve({ success: true, data: sortedResults });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const events = {
    addEventsList,
    getEventsList,
    getEvent,
    getFilteredEventsList,
    getFilteredEventsListByAnimalId,
    findEvents
}

export default events;
